import React from 'react';
import PaginationStyled from './bundle.esm2.js';

const Pagination = (props) => {
  const { numberOfSlides, currentSlide, snapTo } = props;
  const activeClass = "Pagination__dot--active";
  const clickHandler = (e, slide) => {
    e.stopPropagation();
    snapTo(slide);
  };
  if (numberOfSlides === 1)
    return null;
  return /* @__PURE__ */ React.createElement(PaginationStyled, {
    className: "Pagination"
  }, Array(numberOfSlides).fill("").map((_, index) => /* @__PURE__ */ React.createElement("li", {
    className: `Pagination__dot ${index + 1 === currentSlide ? activeClass : ""}`,
    key: index,
    onClick: (e) => clickHandler(e, index + 1)
  })));
};
Pagination.defaultProps = {};

export { Pagination as default };
//# sourceMappingURL=bundle.esm.js.map
